import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "alert alert-primary d-flex align-items-center p-5 mb-10 pulse pulse-primary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "pulse-ring",
  style: {"margin-left":"-3px"}
}, null, -1)
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "mb-1 text-primary" }
const _hoisted_6 = { class: "card mb-5 mb-xl-10" }
const _hoisted_7 = { class: "card-header border-0" }
const _hoisted_8 = { class: "card-title m-0" }
const _hoisted_9 = {
  key: 0,
  class: "fw-bolder m-0"
}
const _hoisted_10 = {
  key: 0,
  class: "card-title m-0"
}
const _hoisted_11 = { class: "collapse show" }
const _hoisted_12 = { class: "card-body border-top p-9" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_34 = { class: "pb-5" }
const _hoisted_35 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_51 = { class: "card mb-5 mb-xl-10" }
const _hoisted_52 = { class: "card-header border-0" }
const _hoisted_53 = { class: "card-title m-0" }
const _hoisted_54 = { class: "fw-bolder m-0" }
const _hoisted_55 = { class: "collapse show" }
const _hoisted_56 = { class: "card-body border-top p-9" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "col-lg-8 fv-row" }
const _hoisted_68 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-8 fv-row" }
const _hoisted_72 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_77 = ["download", "href"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "col-lg-8 fv-row" }
const _hoisted_82 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_83 = ["download", "href"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_85 = { class: "card mb-5 mb-xl-10" }
const _hoisted_86 = { class: "card-header border-0" }
const _hoisted_87 = { class: "card-title m-0" }
const _hoisted_88 = { class: "fw-bolder m-0" }
const _hoisted_89 = { class: "collapse show" }
const _hoisted_90 = { class: "card-body border-top p-9" }
const _hoisted_91 = {
  key: 0,
  class: "separator separator-dashed my-5"
}
const _hoisted_92 = { class: "card mb-5 mb-xl-10" }
const _hoisted_93 = { class: "card-header border-0" }
const _hoisted_94 = { class: "card-title m-0" }
const _hoisted_95 = { class: "fw-bolder m-0" }
const _hoisted_96 = { class: "collapse show" }
const _hoisted_97 = { class: "card-body border-top p-9" }
const _hoisted_98 = { class: "row mb-6" }
const _hoisted_99 = { class: "col-lg-12 fv-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Menor = _resolveComponent("Menor")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _component_CambiarDemarcacionModal = _resolveComponent("CambiarDemarcacionModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_dropdown, { class: "mx-3" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_cambiar_demarcacion"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.cambiarDemarcacion")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (
          (_ctx.familia?.estado === _ctx.FormularioEstado.pendiente ||
            _ctx.familia?.estado === _ctx.FormularioEstado.realizadoPorError ||
            _ctx.familia?.estado === _ctx.FormularioEstado.noApto) &&
          _ctx.datosSolicitud?.nombre
        )
          ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: _ctx.aprobar }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.aprobar.button")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (
                _ctx.familia?.estado === _ctx.FormularioEstado.noApto ||
                _ctx.familia?.estado === _ctx.FormularioEstado.realizadoPorError
              )
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 0,
                          onClick: _ctx.pendiente
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.pendiente.button")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (
                _ctx.familia?.estado === _ctx.FormularioEstado.noApto ||
                _ctx.familia?.estado === _ctx.FormularioEstado.pendiente
              )
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 1,
                          onClick: _ctx.realizadoPorError
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.realizadoPorError.button")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (
                _ctx.familia?.estado === _ctx.FormularioEstado.pendiente ||
                _ctx.familia?.estado === _ctx.FormularioEstado.realizadoPorError
              )
                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: 2,
                          onClick: _ctx.noApto
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.descartar.button")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: 
            _ctx.isLoadingAprobar ||
            _ctx.isLoadingNoApto ||
            _ctx.isLoadingPendiente ||
            _ctx.isLoadingRealizadoPorError
          ,
                  disabled: 
            _ctx.isLoadingAprobar ||
            _ctx.isLoadingNoApto ||
            _ctx.isLoadingPendiente ||
            _ctx.isLoadingRealizadoPorError
          
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.cambiarEstado.button")) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (!_ctx.datosSolicitud.nombre)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/solicitudes/familias/${_ctx.peticionFormularioId}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("formularios.familiaDetalle.alerta.segundaSolicitud.titulo")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("formularios.familiaDetalle.alerta.segundaSolicitud.descripcion")), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.datosSolicitanteGroup')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.familia)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.datosSolicitanteGroup", {
                    codigo: _ctx.familia.codigo,
                  })), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.estado)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.claseEstado)
                          }, _toDisplayString(_ctx.estado), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.tratamiento.text), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.datosSolicitud.nombre + " " + _ctx.datosSolicitud.apellidos), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.datosSolicitud.dni), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.datosSolicitud.email), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.datosSolicitud.telefono), 1)
                        ])
                      ]),
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.datosSolicitud.direccion), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.datosSolicitud.localidad), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("formularios.familiaDetalle.comarca.label")), 1),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_el_select, {
                            disabled: !_ctx.isAdmin,
                            modelValue: _ctx.familiaComarcaId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.familiaComarcaId) = $event)),
                            onChange: _ctx.changeComarca,
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.text,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue", "onChange"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.datosSolicitud.provincia), 1)
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.situacionFamiliarGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("h3", _hoisted_54, _toDisplayString(_ctx.$t("formularios.familiaDetalle.situacionFamiliarGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tipologiaFamilia.label")), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.familiaTipologiaFamilia.nombre), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("formularios.familiaDetalle.numeroMenores.label")), 1),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.familiaNumeroMenores.nombre), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("formularios.familiaDetalle.ingresos.label")), 1),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.ingresos), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t("formularios.familiaDetalle.familiaPrioritaria.label")), 1),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.datosSolicitud.familiaPrioritaria ? "Sí" : "No"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("formularios.familiaDetalle.documentos.label")), 1),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("ul", _hoisted_76, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.libroFamilia, (file, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "el-upload-list__item is-success",
                                tabindex: "0"
                              }, [
                                _createElementVNode("a", {
                                  class: "el-upload-list__item-name",
                                  download: file.nombre,
                                  href: file.data
                                }, [
                                  _createVNode(_component_el_image, {
                                    class: "align-middle",
                                    style: {"width":"100px","height":"100px"},
                                    src: file.data,
                                    fit: "cover"
                                  }, {
                                    error: _withCtx(() => [
                                      _hoisted_78
                                    ]),
                                    _: 2
                                  }, 1032, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                ], 8, _hoisted_77)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t(
                      "formularios.familiaDetalle.documentosIdentificativo.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("ul", _hoisted_82, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dniResponsable, (file, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "el-upload-list__item is-success",
                                tabindex: "0"
                              }, [
                                _createElementVNode("a", {
                                  class: "el-upload-list__item-name",
                                  download: file.nombre,
                                  href: file.data
                                }, [
                                  _createVNode(_component_el_image, {
                                    class: "align-middle",
                                    style: {"width":"100px","height":"100px"},
                                    src: file.data,
                                    fit: "cover"
                                  }, {
                                    error: _withCtx(() => [
                                      _hoisted_84
                                    ]),
                                    _: 2
                                  }, 1032, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                ], 8, _hoisted_83)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.serviciosSolicitados')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("h3", _hoisted_88, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menoresGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menores, (menor, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (i !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_91))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Menor, { menor: menor }, null, 8, ["menor"])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.notas')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("h3", _hoisted_95, _toDisplayString(_ctx.$t("formularios.familiaDetalle.notas")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.notas,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notas) = $event)),
                            autosize: { minRows: 5 },
                            type: "textarea",
                            placeholder: " "
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode(_component_el_button, {
                        class: "float-end",
                        type: "primary",
                        onClick: _ctx.onSubmit,
                        loading: _ctx.notasLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.familiaDetalle.guardarNotas.button")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CambiarDemarcacionModal, { familia: _ctx.familia }, null, 8, ["familia"])
  ], 64))
}